export default {
  //授课讨论
  SKDiscussList: '',
  //讨论详情
  SKDiscussDetails: '',
  //讨论添加
  SKDiscussAdd: '',
  //讨论结束
  SKDiscussOver: '',
  //讨论结果
  SKDiscussRes: '',
  //讨论词云
  SKDiscussWord: '',
  //讨论结果点赞
  SKDiscussPraise: '',
}
